<script type="text/jsx" lang="jsx">
import mixin from '@/plans/mx/shopping-cart';
import planCommon from './mixin';
import deviceMixin from './device-mx';
import { planTypes } from '@/common/constants';
import { mapGetters } from 'vuex';

export default {
  mixins: [planCommon, mixin, deviceMixin],
  computed: {
    ...mapGetters(['getSelectedPlans']),
    selectedDevicePlans() {
      return this.getSelectedPlans.filter(item => item.isVendorProduct)
    },
    selectedDeskPhonePlans() {
      return this.selectedDevicePlans.filter(item => item.type === planTypes.ZOOM_DEVICE$DESK_PHONE)
    },
    selectedHeadsetPlans() {
      return this.selectedDevicePlans.filter(item => item.type === planTypes.ZOOM_DEVICE$HEADSET)
    },
  },
  methods: {
    getPlanQuantity(plan) {
      return plan?.cartInfo?.selected_number || 0
    },
    getPlanAmount(plan) {
      const amount = plan?.amount || 0
      return this.$money(this.getPlanQuantity(plan) * amount)
    },
    $renderPriceForDeskPhone() {
      if (!this.selectedDeskPhonePlans.length) return null

      return (
        <div>
          {this.mx_title(this.$t('billing.hw.desk_phones.addon.title'))}
          {
            this.selectedDeskPhonePlans.map((plan) => {
              return (
                <div key={plan.plan_code} class="desk-phone-cart-item">
                  <div class="desk-phone-cart__row desk-phone-cart__row-subtitle">
                    <span class="desk-phone-cart__row-subtitle-text">{`${plan.planName} ${this.$t('billing.hw.desk_phones.addon.title')}`}</span>
                    <span>{ this.getPlanAmount(plan) }</span>
                  </div>
                  <div class="desk-phone-cart__row desk-phone-cart__row-text">
                    { this.$t('billing.hw.desk_phones.cart.period') }
                  </div>
                  <div class="desk-phone-cart__row desk-phone-cart__row-text">
                    { this.$t('billing.quantity')}: { this.getPlanQuantity(plan) }
                  </div>
                </div>
              );
            })
          }
        </div>
      )
    },
    $renderPriceForHeadset() {
      if (!this.selectedHeadsetPlans.length) return null
      return (
        <div>
          {this.mx_title(this.$t('billing.hw.headset.addon.title'))}
          {
            this.selectedHeadsetPlans.map((plan) => {
              return (
                <div key={plan.plan_code} class="desk-phone-cart-item">
                  <div class="desk-phone-cart__row desk-phone-cart__row-subtitle">
                    <span>{`${plan.planName} ${this.$t('billing.hw.headset.addon.title')}`}</span>
                    <span>{ this.getPlanAmount(plan) }</span>
                  </div>
                  <div class="desk-phone-cart__row desk-phone-cart__row-text">
                    { this.$t('billing.hw.desk_phones.cart.period') }
                  </div>
                  <div class="desk-phone-cart__row desk-phone-cart__row-text">
                    { this.$t('billing.quantity')}: { this.getPlanQuantity(plan) }
                  </div>
                </div>
              );
            })
          }
        </div>
      )
    },
    $renderPrice() {
      return (
        <div>
          {this.$renderPriceForDeskPhone()}
          {this.$renderPriceForHeadset()}
          <div class="desk-phone-cart__shipping">
            <span class="desk-phone-cart__shipping-text">{ this.$t('billing.hw.desk_phones.cart.shipped_from') }</span>
            <span>{ this.$t('billing.hw.desk_phones.cart.shipped_free') }</span>
          </div>
          <div class="desk-phone-cart__privacy hide-in-success">
            <zm-link href={this.mx_privacyPolicy} target="_blank">{this.$t('billing.hw.desk_phones.cart.privacy')}</zm-link>
            <span> | </span>
            <zm-link href={this.mx_returnPolicy} target="_blank">{this.$t('billing.hw.desk_phones.cart.return_policy')}</zm-link>
          </div>
          <div class="only-show-in-success desk-phone-cart__privacy">
            <zm-link class="opc-success-no-hide-button" href={this.mx_rmaUrl} target="_blank">{ this.$t('billing.hw.ram') }</zm-link>
            <span> | </span>
            <zm-link class="opc-success-no-hide-button" href={this.mx_helpUrl} target="_blank">{ this.$t('billing.hw.support_form') }</zm-link>
          </div>
        </div>
      )
    }
  },
};
</script>
<style lang="scss" scoped>
.only-show-in-success {
  display: none;
}
</style>
<style lang="scss">
.desk-phone-cart {
  .desk-phone-cart-item {
    margin-bottom: 10px;
  }
  &__row {
    display: flex;
    justify-content: space-between;

    color: var(--zoom-color-text-neutral, #686F79);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 21px */

    &-subtitle {
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);

      &-text {
        font-weight: 600;
      }
    }
  }
  &__shipping {
    display: flex;
    justify-content: space-between;
    color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    font-size: 14px;
    font-style: normal;
    line-height: 150%; /* 21px */
    &-text {
      font-weight: 600;
    }
  }
  &__privacy {
    color: var(--zoom-color-text-neutral, #686F79);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
  }
}
</style>
